export default __webpack_public_path__ + "static/media/cancel.ccc7f42e.png";